const allergenList = [
  { name: "Celery", contains: false },
  { name: "Gluten", contains: false },
  { name: "Crustacean", contains: false },
  { name: "Egg", contains: false },
  { name: "Fish", contains: false },
  { name: "Lupin", contains: false },
  { name: "Milk", contains: false },
  { name: "Mollusc", contains: false },
  { name: "Mustard", contains: false },
  { name: "Tree Nut", contains: false },
  { name: "Peanut", contains: false },
  { name: "Sesame Seed", contains: false },
  { name: "Soya", contains: false },
  { name: "Sulphur Dioxide", contains: false },
];

const state = () => ({
  allergens: [],
  customerAllergens: [],
  cartAllergens: [],
  mutatedAllergenList: allergenList,
});

const getters = {
  allergens: (state) => state.allergens,
  allergensProducts: (state, getters, rootState, rootGetters) => {
    return rootState.cart.added;
  },
  orderAllergens: (state, getters, rootState, rootGetters) => {
    let productAllergens = [];
    let modifierAllergens = [];

    rootState.cart.added.map((item) => {
      if ("allergens" in item && item.allergens !== undefined) {
        item.allergens.map((a) => {
          if (a.contains) productAllergens.push(a.name);
        });
      }

      Object.values(item.modifiers).map((modifierSet) => {
        modifierSet.map((modifier) => {
          if (modifier.allergens) {
            modifier.allergens.map((a) => {
              if (a.contains) modifierAllergens.push(a.name);
            });
          }
        });
      });
    });

    let vals = productAllergens.concat(modifierAllergens);
    state.cartAllergens = [...new Set(vals)];
    return state.cartAllergens;
  },
  customerAllergens: (state) => state.customerAllergens,
  conflictingAllergens: (state) => {
    let found = [];
    state.customerAllergens.map((allergy) => {
      found.push(state.cartAllergens.includes(allergy));
    });
    return found.includes(true);
  },
  conflictingAllergenList: (state) => {
    let conflicting = [];
    state.customerAllergens.map((allergy) => {
      if (state.cartAllergens.includes(allergy)) conflicting.push(allergy);
    });
    return conflicting;
  },
  getCustomerAllergenList: (state) => {
    return state.mutatedAllergenList.map((allergen) => {
      return {
        name: allergen.name,
        contains: state.customerAllergens.includes(allergen.name),
      };
    });
  },
};

const actions = {
  updateCustomerAllergens({ commit }, allergens) {
    commit("updateAllergensMutation", allergens);
  },
  clearAllergensList({ commit }) {
    commit("clearAllergensListMutation");
  },
};

const mutations = {
  updateAllergensMutation(state, allergens) {
    let len = allergens.length - state.allergens.length;
    if (len > 0) {
      state.mutatedAllergenList = allergens.slice((len*-1));
    }
    state.customerAllergens = allergens.filter((allergen) => allergen.contains).map((a) => a.name);
  },
  clearAllergensListMutation(state) {
    state.customerAllergens = [];
    state.mutatedAllergenList = allergenList;
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
